export * from './dossierBaseSub.component';
export * from './dossierBaseArray.component';
export * from './address';
export * from './addressInfo';
export * from './contactInfo';
export * from './divisions';
export * from './documentInfo';
export * from './fio';
export * from './license';
export * from './licenseInfo';
export * from './updateCard';
export * from './updateCardInfo';
export * from './migrationCardInfo';
export * from './okved';
export * from './orgName';
export * from './personalData';
export * from './publicInfo';
export * from './regInfo';
export * from './regInfoCP';
export * from './regInfoInbUL';
export * from './residenceDocInfo';
export * from './svedFL';
export * from './svedFLCP';
export * from './svedInbUL';
export * from './svedIP';
export * from './svedUL';
export * from './svedKO';
export * from './iouInfo';
export * from './bvInfo';
export * from './predstInfo';
export * from './account';
export * from './dokReestrInfo';
export * from './authority';
export * from './version';
export * from './clientInfo';
export * from './auInfo';
export * from './networkInfo';
export * from './network';
export * from './accessInfo';
export * from './checkRiskAccess';
export * from './dateFromDateEnd';
export * from './stopPowers';
export * from './vprInfo';
export * from './riskAccessInfo';
